import React from "react";
import { Box } from "@mui/material";
import { mmkScrollShellStyles, mmkContainerInnerStyles } from "./styles";

// Full-width scroll (scrollbar at screen edge) + centered content column.
export const MmkPageShell: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Box sx={mmkScrollShellStyles}>
    <Box sx={mmkContainerInnerStyles}>
      {children}
      {/* Spacer so last content never sits under the MMM tab footer. */}
      <Box
        aria-hidden
        sx={{ height: { xs: 16, sm: 24 }, flexShrink: 0, width: "100%" }}
      />
    </Box>
  </Box>
);
